/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Content4 from './Content4';
import Feature0 from './Feature0';
import Feature5 from './Feature5';
import Feature6 from './Feature6';
import StartingBanner from './StartingBanner';



import {
  Content40DataSource,
  Feature00DataSource,
  Feature60DataSource,
  Feature50DataSource,
} from './data.source';
import './less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});


export default class SchoolApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      direction: "rtl"
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });

  }

  render() {
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        <Content4
          id="Content4_0"
          key="Content4_0"
          dataSource={Content40DataSource}
          isMobile={this.state.isMobile}
        />
        <Feature0
          id="Feature0_0"
          key="Feature0_0"
          dataSource={Feature00DataSource}
          isMobile={this.state.isMobile}
        />
        <Feature6
          id="Feature6_0"
          key="Feature6_0"
          dataSource={Feature60DataSource}
          dir={this.state.direction}
          isMobile={this.state.isMobile}
        />
        <Feature5
          id="Feature5_0"
          key="Feature5_0"
          dataSource={Feature50DataSource}
          isMobile={this.state.isMobile}
        />
        <StartingBanner
          id="starting_banner"
          key="starting_banner"
          dir={this.state.direction}
        />
      </div>



    );
  }
}
